import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class BillingUsageService {

    constructor() {
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.BILLING_USAGE = '/api/billing/usage';
        this.CURRENT_FOR_ORG = '/org/{orgId}/current';
        this.GET_HISTORY = '/org/{orgId}/history';
    }

    async getCurrentUsageByOrgId(orgId) {
        try {
            let url = window.location.origin + this.BILLING_USAGE + this.CURRENT_FOR_ORG;
            url = url.replace('{orgId}', orgId);
            return this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if (data.error !== undefined) {
                        if (data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                });
        } catch (err) {
            console.log(err);
        }
    }


    async getHistoryByOrgId(orgId) {
        try {
            let url = window.location.origin + this.BILLING_USAGE + this.GET_HISTORY;
            url = url.replace('{orgId}', orgId);
            return this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if (data.error !== undefined) {
                        if (data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                });
        } catch (err) {
            console.log(err);
        }
    }

}

export default BillingUsageService;
